import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";
import { CommonRequest } from "@/types/http";
import { LembarObservasiAsuhanKebidanan } from "@/types/LembarObservasiAsuhanKebidanan";

const base = "/lembar-observasi-asuhan-kebidanan";

async function create(
  data: Partial<LembarObservasiAsuhanKebidanan>
): Promise<CommonRequest<any>> {
  const response = await http.postData(base, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response.data;
}

async function update(
  id: number,
  data: Partial<LembarObservasiAsuhanKebidanan>
): Promise<CommonRequest<any>> {
  const response = await http.putData(`${base}/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response.data;
}

async function find(id: number): Promise<CommonRequest<any>> {
  const response = await http.getData(`${base}/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response.data;
}

async function getByRegister(
  register_id: string | number
): Promise<CommonRequest<any>> {
  const response = await http
    .getData(`${base}/register/${register_id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function destroy(id: number): Promise<CommonRequest<undefined>> {
  const response = await http.deleteData(`${base}/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response.data;
}

async function signBidan(
  id: number,
  data: any = {}
): Promise<CommonRequest<any>> {
  const response = await http
    .postData(`${base}/${id}/sign-bidan`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function signDpjp(
  id: number,
  data: any = {}
): Promise<CommonRequest<any>> {
  const response = await http
    .postData(`${base}/${id}/sign-dpjp`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

function pdfUrl(id: number): string {
  return `${http.getAPI()}${base}/${id}/pdf`;
}

function printPdf(id: number) {
  window.open(pdfUrl(id), "_blank");
}

export default {
  create,
  update,
  find,
  getByRegister,
  destroy,
  signBidan,
  signDpjp,
  pdfUrl,
  printPdf
};
